import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { GET_COOKIE_CONSENT_INFO } from '@whitbread-eos/api';
import { ModalVariants } from '@whitbread-eos/atoms';
import { DYNATRACE_CONSENT_COOKIE_NAME, getDynatraceConsentPaths, setCookie, syncDynatraceConsent, useCustomLocale, useQueryRequest } from '@whitbread-eos/utils';
import { useEffect, useState } from 'react';
import { CONSENT_COOKIE } from './CookiePolicies.constants';
import CookiePolicies from './CookiePolicies/CookiePolicies.component';
import ManageCookies from './ManageCookies/ManageCookies.component';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export default function CookiePoliciesModalContainer(_ref) {
  var _cookieConsent, _cookiePolicies$confi, _cookiePolicies$confi2, _cookiePolicies$confi3, _cookiePolicies$confi4, _cookiePolicies$intro;
  var onClose = _ref.onClose,
    isOpen = _ref.isOpen,
    brand = _ref.brand,
    _ref$isDynatraceRumCo = _ref.isDynatraceRumCookieConsentEnabled,
    isDynatraceRumCookieConsentEnabled = _ref$isDynatraceRumCo === void 0 ? false : _ref$isDynatraceRumCo;
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language,
    country = _useCustomLocale.country;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isManageCookieModalOpen = _useState2[0],
    setIsManageCookieModalOpen = _useState2[1];
  var cookieDomain = process.env.NEXT_PUBLIC_COOKIES_DOMAIN;
  var _useQueryRequest = useQueryRequest(['getCookieConsentInfoQuery', country, language, brand], GET_COOKIE_CONSENT_INFO, {
      country,
      language,
      brand
    }, {
      select: data => {
        var _data$cookieConsent;
        if (data !== null && data !== void 0 && (_data$cookieConsent = data.cookieConsent) !== null && _data$cookieConsent !== void 0 && (_data$cookieConsent = _data$cookieConsent.cookiePolicies) !== null && _data$cookieConsent !== void 0 && (_data$cookieConsent = _data$cookieConsent.manageView) !== null && _data$cookieConsent !== void 0 && (_data$cookieConsent = _data$cookieConsent.cookieGroup) !== null && _data$cookieConsent !== void 0 && _data$cookieConsent.map) {
          data.cookieConsent.cookiePolicies.manageView.cookieGroup.forEach(group => {
            if (group.cookieName === 'permissionEssential') {
              group.isAlwaysActive = true;
            }
          });
        }
        return data;
      }
    }),
    data = _useQueryRequest.data;
  var cookiePolicies = data === null || data === void 0 || (_cookieConsent = data.cookieConsent) === null || _cookieConsent === void 0 ? void 0 : _cookieConsent.cookiePolicies;
  var manageCookies = () => {
    setIsManageCookieModalOpen(true);
  };
  var defaultCookiesPermissions = cookiePolicies === null || cookiePolicies === void 0 ? void 0 : cookiePolicies.manageView.cookieGroup.map((cookie, index) => {
    return {
      id: index,
      name: cookie.cookieName,
      value: cookie.isAlwaysActive
    };
  });
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    cookiePermissions = _useState4[0],
    setCookiePermissions = _useState4[1];
  useEffect(() => {
    if (data) {
      setCookiePermissions(defaultCookiesPermissions);
    }
  }, [data]);
  var COOKIE_OPT_IN_EXPIRY_DAYS = 60 * 24 * ((_cookiePolicies$confi = cookiePolicies === null || cookiePolicies === void 0 || (_cookiePolicies$confi2 = cookiePolicies.config) === null || _cookiePolicies$confi2 === void 0 ? void 0 : _cookiePolicies$confi2.cookieOptInExpiryDays) !== null && _cookiePolicies$confi !== void 0 ? _cookiePolicies$confi : 365);
  var COOKIE_OPT_OUT_EXPIRY_DAYS = 60 * 24 * ((_cookiePolicies$confi3 = cookiePolicies === null || cookiePolicies === void 0 || (_cookiePolicies$confi4 = cookiePolicies.config) === null || _cookiePolicies$confi4 === void 0 ? void 0 : _cookiePolicies$confi4.cookieOptOutExpiryDays) !== null && _cookiePolicies$confi3 !== void 0 ? _cookiePolicies$confi3 : 365);
  var setCookiePolicies = cookiePermissionsParam => {
    var permissions = cookiePermissionsParam !== null && cookiePermissionsParam !== void 0 ? cookiePermissionsParam : cookiePermissions;
    var performanceCookie;
    permissions === null || permissions === void 0 || permissions.forEach(permission => {
      cookiePolicies === null || cookiePolicies === void 0 || cookiePolicies.manageView.cookieGroup.forEach(cookie => {
        if (cookie.cookieName !== 'permissionEssential' && cookie.cookieName === permission.name) {
          setCookie(cookie.cookieName, permission.value, !permission.value ? COOKIE_OPT_OUT_EXPIRY_DAYS : COOKIE_OPT_IN_EXPIRY_DAYS, "/".concat(country), undefined, cookieDomain);
          if (permission.name === 'permissionPerformance') {
            performanceCookie = permission.value;
          }
          setCookie(cookie.cookieName, permission.value, !permission.value ? COOKIE_OPT_OUT_EXPIRY_DAYS : COOKIE_OPT_IN_EXPIRY_DAYS, "/".concat(language, "-").concat(country), undefined, cookieDomain);
          if (permission.name === DYNATRACE_CONSENT_COOKIE_NAME) {
            syncDynatraceConsent({
              hasConsent: permission.value,
              isEnabled: isDynatraceRumCookieConsentEnabled,
              expiryMinutes: permission.value ? COOKIE_OPT_IN_EXPIRY_DAYS : COOKIE_OPT_OUT_EXPIRY_DAYS,
              paths: getDynatraceConsentPaths(language, country),
              domain: cookieDomain
            });
          }
        }
      });
    });
    setCookie(CONSENT_COOKIE, 1, performanceCookie ? COOKIE_OPT_IN_EXPIRY_DAYS : COOKIE_OPT_OUT_EXPIRY_DAYS, "/".concat(country), undefined, cookieDomain);
    setCookie(CONSENT_COOKIE, 1, performanceCookie ? COOKIE_OPT_IN_EXPIRY_DAYS : COOKIE_OPT_OUT_EXPIRY_DAYS, "/".concat(language, "-").concat(country), undefined, cookieDomain);
    onClose();
  };
  return _jsx(_Fragment, {
    children: data && _jsx(ModalVariants, {
      isOpen: isOpen,
      onClose: onClose,
      dataTestId: 'CookiePolicyContainer',
      variant: "cookie",
      variantProps: {
        title: !isManageCookieModalOpen ? cookiePolicies === null || cookiePolicies === void 0 || (_cookiePolicies$intro = cookiePolicies.introView) === null || _cookiePolicies$intro === void 0 ? void 0 : _cookiePolicies$intro.title : cookiePolicies === null || cookiePolicies === void 0 ? void 0 : cookiePolicies.manageView.title,
        closeOnOverlayClick: false,
        overflowVisible: false,
        isCentered: true,
        isCookieConsentModal: !isManageCookieModalOpen
      },
      children: !isManageCookieModalOpen ? _jsx(CookiePolicies, {
        labels: data,
        cookiePermissions: cookiePermissions,
        setCookiePolicies: setCookiePolicies,
        manageCookies: manageCookies,
        modalStyles: {
          wrapperStyles,
          buttonsStyle,
          textStyles
        }
      }) : _jsx(ManageCookies, {
        labels: data,
        cookiePermissions: cookiePermissions,
        setCookiePermissions: setCookiePermissions,
        setCookiePolicies: setCookiePolicies,
        modalStyles: {
          wrapperStyles,
          textStyles,
          buttonsStyle
        }
      })
    })
  });
}
var wrapperStyles = {
  alignItems: 'center',
  justifyContent: 'center',
  direction: 'column',
  padding: 'lg'
};
var buttonsStyle = {
  display: 'flex',
  height: 'auto',
  alignContent: 'baseline',
  flexDirection: {
    mobile: 'column',
    xs: 'column',
    md: 'row',
    sm: 'row'
  },
  width: '100%'
};
var textStyles = {
  title: {
    color: 'darkGrey1',
    fontWeight: 'semibold',
    fontSize: 'xl',
    lineHeight: '3'
  },
  description: {
    color: 'darkGrey1',
    textAlign: 'left',
    fontWeight: 'normal',
    fontSize: 'md',
    lineHeight: '3'
  }
};